const rows = () => [...document.querySelectorAll('[data-admin-product-id]')];

export function captureProductListPosition() {
  return rows().map(row => ({
    id: row.getAttribute('data-admin-product-id'),
    bounds: row.getBoundingClientRect(),
  })).filter(({ bounds }) => bounds.bottom > 0 && bounds.top < window.innerHeight)
    .map(({ id, bounds }) => ({ id, top: bounds.top }));
}

export function restoreProductListPosition(anchors) {
  const currentRows = rows();
  for (const anchor of anchors) {
    const row = currentRows.find(node => node.getAttribute('data-admin-product-id') === anchor.id);
    if (!row) continue;
    const offset = row.getBoundingClientRect().top - anchor.top;
    if (Math.abs(offset) > 1) window.scrollBy({ top: offset, left: 0, behavior: 'auto' });
    return;
  }
}
